import View from '../../view.js';
import DataTables from '../../components/dataTables.js';
import moment from 'moment-timezone';

class ExporterRestoreJobs extends View {
  constructor(props = {}) {
    super(props);
  }

  get dom() {
    return {
      TABLE: '.exporter-restore-jobs',
    };
  }

  _ensureDefaultElement() {
    this._setElement('#main-content');
  }

  render() {
    let table = this.$(this.dom.TABLE),
      options;

    options = {
      serverSide: true,
      el: table,
      columns: window.da_grid_columns,
      filter: true,
      fixed: false,
      ajaxSource: table.data('source'),
      sorting: [[0, 'desc']],
      createdRow: function (row, data) {
        if (data[0] === 'failed') {
          $(row).find('td:eq(0)').addClass('capitalize');
          $(row).find('td').addClass('error');
        }
      },
      rowCallback: function (row, data) {
        $('td:eq(0)', row).html(data[0].replace('_', ' '));

        // Format exporter job date in details column
        let detailsCell = $(row).find('.exporter-job-date');
        if (detailsCell.length > 0) {
          let dateIso = detailsCell.data('date');
          if (dateIso) {
            let formattedDate = moment(dateIso)
              .tz(moment.tz.guess())
              .format('dddd, MMMM Do YYYY, h:mm:ss a z');
            detailsCell.text(formattedDate);
          }
        }
      },
    };

    options.aoColumnDefs = [
      {
        aTargets: [1, 2],
        mRender: function (data) {
          return (
            data &&
            moment(data)
              .tz(moment.tz.guess())
              .format('dddd, MMMM Do YYYY, h:mm:ss a z')
          );
        },
      },
    ];

    this.table = new DataTables(options);
    this.table.start();
  }

  afterRender() {
    Messenger.on(`/${currentCustomer}/exporters_restore_jobs`, () => {
      setTimeout(() => {
        if (this.table) {
          try {
            this.table.reload();
          } catch (e) {
            console.warn('Failed to reload table:', e);
          }
        }
      }, 1000);
    });
  }
}

module.exports = ExporterRestoreJobs;
